export const yogaData = (t) => ({
  VataPitta: {
    asans: {
      "vp_as_1": t("vp_as_1"),
      "vp_as_2": t("vp_as_2"),
      "vp_as_3": t("vp_as_3"),
      "vp_as_4": t("vp_as_4"),
      "vp_as_5": t("vp_as_5"),
      "vp_as_6": t("vp_as_6"),
      "vp_as_7": t("vp_as_7"),
      "vp_as_8": t("vp_as_8"),
      "vp_as_9": t("vp_as_9"),
      "vp_as_10": t("vp_as_10"),
      "vp_as_11": t("vp_as_11"),
    },
    sets: {
      "vp_as_sets_1": t("vp_as_sets_1"),
      "vp_as_sets_2": t("vp_as_sets_2"),
      "vp_as_sets_3": t("vp_as_sets_3"),
      "vp_as_sets_4": t("vp_as_sets_4"),
      "vp_as_sets_5": t("vp_as_sets_5"),
      "vp_as_sets_6": t("vp_as_sets_6"),
      "vp_as_sets_7": t("vp_as_sets_7"),
      "vp_as_sets_8": t("vp_as_sets_8"),
      "vp_as_sets_9": t("vp_as_sets_9"),
      "vp_as_sets_10": t("vp_as_sets_10"),
      "vp_as_sets_11": t("vp_as_sets_11"),
    },
    duration: {
      "vp_as_dur_1": t("vp_as_dur_1"),
      "vp_as_dur_2": t("vp_as_dur_2"),
      "vp_as_dur_3": t("vp_as_dur_3"),
      "vp_as_dur_4": t("vp_as_dur_4"),
      "vp_as_dur_5": t("vp_as_dur_5"),
      "vp_as_dur_6": t("vp_as_dur_6"),
      "vp_as_dur_7": t("vp_as_dur_7"),
      "vp_as_dur_8": t("vp_as_dur_8"),
      "vp_as_dur_9": t("vp_as_dur_9"),
      "vp_as_dur_10": t("vp_as_dur_10"),
      "vp_as_dur_11": t("vp_as_dur_11"),
    },
    focus: {
      "vp_as_focus_1": t("vp_as_focus_1"),
      "vp_as_focus_2": t("vp_as_focus_2"),
      "vp_as_focus_3": t("vp_as_focus_3"),
      "vp_as_focus_4": t("vp_as_focus_4"),
      "vp_as_focus_5": t("vp_as_focus_5"),
      "vp_as_focus_6": t("vp_as_focus_6"),
      "vp_as_focus_7": t("vp_as_focus_7"),
      "vp_as_focus_8": t("vp_as_focus_8"),
      "vp_as_focus_9": t("vp_as_focus_9"),
      "vp_as_focus_10": t("vp_as_focus_10"),
      "vp_as_focus_11": t("vp_as_focus_11"),
    },
    notes: {
      "vp_as_note_1": t("vp_as_note_1"),
      "vp_as_note_2": t("vp_as_note_2"),
      "vp_as_note_3": t("vp_as_note_3"),
      "vp_as_note_4": t("vp_as_note_4"),
      "vp_as_note_5": t("vp_as_note_5"),
      "vp_as_note_6": t("vp_as_note_6"),
      "vp_as_note_7": t("vp_as_note_7"),
      "vp_as_note_8": t("vp_as_note_8"),
      "vp_as_note_9": t("vp_as_note_9"),
      "vp_as_note_10": t("vp_as_note_10"),
      "vp_as_note_11": t("vp_as_note_11"),
    },
  },
  VataKapha: {
    asans: {
      "vk_as_1": t("vk_as_1"),
      "vk_as_2": t("vk_as_2"),
      "vk_as_3": t("vk_as_3"),
      "vk_as_4": t("vk_as_4"),
      "vk_as_5": t("vk_as_5"),
      "vk_as_6": t("vk_as_6"),
      "vk_as_7": t("vk_as_7"),
      "vk_as_8": t("vk_as_8"),
      "vk_as_9": t("vk_as_9"),
    },
    sets: {
      "vk_as_sets_1": t("vk_as_sets_1"),
      "vk_as_sets_2": t("vk_as_sets_2"),
      "vk_as_sets_3": t("vk_as_sets_3"),
      "vk_as_sets_4": t("vk_as_sets_4"),
      "vk_as_sets_5": t("vk_as_sets_5"),
      "vk_as_sets_6": t("vk_as_sets_6"),
      "vk_as_sets_7": t("vk_as_sets_7"),
      "vk_as_sets_8": t("vk_as_sets_8"),
      "vk_as_sets_9": t("vk_as_sets_9"),
    },
    duration: {
      "vk_as_dur_1": t("vk_as_dur_1"),
      "vk_as_dur_2": t("vk_as_dur_2"),
      "vk_as_dur_3": t("vk_as_dur_3"),
      "vk_as_dur_4": t("vk_as_dur_4"),
      "vk_as_dur_5": t("vk_as_dur_5"),
      "vk_as_dur_6": t("vk_as_dur_6"),
      "vk_as_dur_7": t("vk_as_dur_7"),
      "vk_as_dur_8": t("vk_as_dur_8"),
      "vk_as_dur_9": t("vk_as_dur_9"),
    },
    focus: {
      "vk_as_focus_1": t("vk_as_focus_1"),
      "vk_as_focus_2": t("vk_as_focus_2"),
      "vk_as_focus_3": t("vk_as_focus_3"),
      "vk_as_focus_4": t("vk_as_focus_4"),
      "vk_as_focus_5": t("vk_as_focus_5"),
      "vk_as_focus_6": t("vk_as_focus_6"),
      "vk_as_focus_7": t("vk_as_focus_7"),
      "vk_as_focus_8": t("vk_as_focus_8"),
      "vk_as_focus_9": t("vk_as_focus_9"),
    },
    notes: {
      "vk_as_note_1": t("vk_as_note_1"),
      "vk_as_note_2": t("vk_as_note_2"),
      "vk_as_note_3": t("vk_as_note_3"),
      "vk_as_note_4": t("vk_as_note_4"),
      "vk_as_note_5": t("vk_as_note_5"),
      "vk_as_note_6": t("vk_as_note_6"),
      "vk_as_note_7": t("vk_as_note_7"),
      "vk_as_note_8": t("vk_as_note_8"),
      "vk_as_note_9": t("vk_as_note_9"),
    },
  },
  PittaVata: {
    asans: {
      "pv_as_1": t("pv_as_1"),
      "pv_as_2": t("pv_as_2"),
      "pv_as_3": t("pv_as_3"),
      "pv_as_4": t("pv_as_4"),
      "pv_as_5": t("pv_as_5"),
      "pv_as_6": t("pv_as_6"),
    },
    sets: {
      "pv_as_sets_1": t("pv_as_sets_1"),
      "pv_as_sets_2": t("pv_as_sets_2"),
      "pv_as_sets_3": t("pv_as_sets_3"),
      "pv_as_sets_4": t("pv_as_sets_4"),
      "pv_as_sets_5": t("pv_as_sets_5"),
      "pv_as_sets_6": t("pv_as_sets_6"),
    },
    duration: {
      "pv_as_dur_1": t("pv_as_dur_1"),
      "pv_as_dur_2": t("pv_as_dur_2"),
      "pv_as_dur_3": t("pv_as_dur_3"),
      "pv_as_dur_4": t("pv_as_dur_4"),
      "pv_as_dur_5": t("pv_as_dur_5"),
      "pv_as_dur_6": t("pv_as_dur_6"),
    },
    focus: {
      "pv_as_focus_1": t("pv_as_focus_1"),
      "pv_as_focus_2": t("pv_as_focus_2"),
      "pv_as_focus_3": t("pv_as_focus_3"),
      "pv_as_focus_4": t("pv_as_focus_4"),
      "pv_as_focus_5": t("pv_as_focus_5"),
      "pv_as_focus_6": t("pv_as_focus_6"),
    },
    notes: {
      "pv_as_note_1": t("pv_as_note_1"),
      "pv_as_note_2": t("pv_as_note_2"),
      "pv_as_note_3": t("pv_as_note_3"),
      "pv_as_note_4": t("pv_as_note_4"),
      "pv_as_note_5": t("pv_as_note_5"),
      "pv_as_note_6": t("pv_as_note_6"),
    },
  },
  PittaKapha: {
    asans: {
      "pk_as_1": t("pk_as_1"),
      "pk_as_2": t("pk_as_2"),
      "pk_as_3": t("pk_as_3"),
      "pk_as_4": t("pk_as_4"),
      "pk_as_5": t("pk_as_5"),
      "pk_as_6": t("pk_as_6"),
      "pk_as_7": t("pk_as_7"),
      "pk_as_8": t("pk_as_8"),
      "pk_as_9": t("pk_as_9"),
    },
    sets: {
      "pk_as_sets_1": t("pk_as_sets_1"),
      "pk_as_sets_2": t("pk_as_sets_2"),
      "pk_as_sets_3": t("pk_as_sets_3"),
      "pk_as_sets_4": t("pk_as_sets_4"),
      "pk_as_sets_5": t("pk_as_sets_5"),
      "pk_as_sets_6": t("pk_as_sets_6"),
      "pk_as_sets_7": t("pk_as_sets_7"),
      "pk_as_sets_8": t("pk_as_sets_8"),
      "pk_as_sets_9": t("pk_as_sets_9"),
    },
    duration: {
      "pk_as_dur_1": t("pk_as_dur_1"),
      "pk_as_dur_2": t("pk_as_dur_2"),
      "pk_as_dur_3": t("pk_as_dur_3"),
      "pk_as_dur_4": t("pk_as_dur_4"),
      "pk_as_dur_5": t("pk_as_dur_5"),
      "pk_as_dur_6": t("pk_as_dur_6"),
      "pk_as_dur_7": t("pk_as_dur_7"),
      "pk_as_dur_8": t("pk_as_dur_8"),
      "pk_as_dur_9": t("pk_as_dur_9"),
    },
    focus: {
      "pk_as_focus_1": t("pk_as_focus_1"),
      "pk_as_focus_2": t("pk_as_focus_2"),
      "pk_as_focus_3": t("pk_as_focus_3"),
      "pk_as_focus_4": t("pk_as_focus_4"),
      "pk_as_focus_5": t("pk_as_focus_5"),
      "pk_as_focus_6": t("pk_as_focus_6"),
      "pk_as_focus_7": t("pk_as_focus_7"),
      "pk_as_focus_8": t("pk_as_focus_8"),
      "pk_as_focus_9": t("pk_as_focus_9"),
    },
    notes: {
      "pk_as_note_1": t("pk_as_note_1"),
      "pk_as_note_2": t("pk_as_note_2"),
      "pk_as_note_3": t("pk_as_note_3"),
      "pk_as_note_4": t("pk_as_note_4"),
      "pk_as_note_5": t("pk_as_note_5"),
      "pk_as_note_6": t("pk_as_note_6"),
      "pk_as_note_7": t("pk_as_note_7"),
      "pk_as_note_8": t("pk_as_note_8"),
      "pk_as_note_9": t("pk_as_note_9"),
    },
  },
  KaphaVata: {
    asans: {
      "kv_as_1": t("kv_as_1"),
      "kv_as_2": t("kv_as_2"),
      "kv_as_3": t("kv_as_3"),
      "kv_as_4": t("kv_as_4"),
      "kv_as_5": t("kv_as_5"),
      "kv_as_6": t("kv_as_6"),
      "kv_as_7": t("kv_as_7"),
      "kv_as_8": t("kv_as_8"),
    },
    sets: {
      "kv_as_sets_1": t("kv_as_sets_1"),
      "kv_as_sets_2": t("kv_as_sets_2"),
      "kv_as_sets_3": t("kv_as_sets_3"),
      "kv_as_sets_4": t("kv_as_sets_4"),
      "kv_as_sets_5": t("kv_as_sets_5"),
      "kv_as_sets_6": t("kv_as_sets_6"),
      "kv_as_sets_7": t("kv_as_sets_7"),
      "kv_as_sets_8": t("kv_as_sets_8"),
    },
    duration: {
      "kv_as_dur_1": t("kv_as_dur_1"),
      "kv_as_dur_2": t("kv_as_dur_2"),
      "kv_as_dur_3": t("kv_as_dur_3"),
      "kv_as_dur_4": t("kv_as_dur_4"),
      "kv_as_dur_5": t("kv_as_dur_5"),
      "kv_as_dur_6": t("kv_as_dur_6"),
      "kv_as_dur_7": t("kv_as_dur_7"),
      "kv_as_dur_8": t("kv_as_dur_8"),
    },
    focus: {
      "kv_as_focus_1": t("kv_as_focus_1"),
      "kv_as_focus_2": t("kv_as_focus_2"),
      "kv_as_focus_3": t("kv_as_focus_3"),
      "kv_as_focus_4": t("kv_as_focus_4"),
      "kv_as_focus_5": t("kv_as_focus_5"),
      "kv_as_focus_6": t("kv_as_focus_6"),
      "kv_as_focus_7": t("kv_as_focus_7"),
      "kv_as_focus_8": t("kv_as_focus_8"),
    },
    notes: {
      "kv_as_note_1": t("kv_as_note_1"),
      "kv_as_note_2": t("kv_as_note_2"),
      "kv_as_note_3": t("kv_as_note_3"),
      "kv_as_note_4": t("kv_as_note_4"),
      "kv_as_note_5": t("kv_as_note_5"),
      "kv_as_note_6": t("kv_as_note_6"),
      "kv_as_note_7": t("kv_as_note_7"),
      "kv_as_note_8": t("kv_as_note_8"),
    },
  },
  KaphaPitta: {
    asans: {
      "kp_as_1": t("kp_as_1"),
      "kp_as_2": t("kp_as_2"),
      "kp_as_3": t("kp_as_3"),
      "kp_as_4": t("kp_as_4"),
    },
    sets: {
      "kp_as_sets_1": t("kp_as_sets_1"),
      "kp_as_sets_2": t("kp_as_sets_2"),
      "kp_as_sets_3": t("kp_as_sets_3"),
      "kp_as_sets_4": t("kp_as_sets_4"),
    },
    duration: {
      "kp_as_dur_1": t("kp_as_dur_1"),
      "kp_as_dur_2": t("kp_as_dur_2"),
      "kp_as_dur_3": t("kp_as_dur_3"),
      "kp_as_dur_4": t("kp_as_dur_4"),
    },
    focus: {
      "kp_as_focus_1": t("kp_as_focus_1"),
      "kp_as_focus_2": t("kp_as_focus_2"),
      "kp_as_focus_3": t("kp_as_focus_3"),
      "kp_as_focus_4": t("kp_as_focus_4"),
    },
    notes: {
      "kp_as_note_1": t("kp_as_note_1"),
      "kp_as_note_2": t("kp_as_note_2"),
      "kp_as_note_3": t("kp_as_note_3"),
      "kp_as_note_4": t("kp_as_note_4"),
    },
  },
});
